import { useMsal } from "@azure/msal-react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, LinearProgress } from "@material-ui/core";
import React, { ReactElement, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { getHealth, selectStatus } from "./globalDialogSlice";
import { globalDialogStatus } from "./globalDialogTypes";

export default function GlobalDialog(): ReactElement {
  const { instance } = useMsal();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getHealth(1));
    progressTimer();
  }, [instance]);

  const status = useAppSelector(selectStatus);

  const [progress, setProgress] = useState(0);

  // eslint-disable-next-line scanjs-rules/call_setInterval
  const progressTimer = () => setInterval(() => {
    setProgress((oldProgress) => Math.min(oldProgress + 2.5, 100));
  }, 500);

  return (
    <div>
      <Dialog open={true}>
        {status == globalDialogStatus.loadFailed ?
          <><DialogTitle>Herzlich Willkommen bei Power Quality der TransnetBW</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Leider konnte die Applikation nicht geladen werden.<br />
                Bitte prüfen Sie die Verbindung zum TransnetBW-Intranet.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                color="secondary"
                variant="contained"
                onClick={() => history.go(0)}
              >
                Neuladen
              </Button>
            </DialogActions></>
          : <><DialogTitle>Herzlich Willkommen bei Power Quality der TransnetBW</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Bitte warten Sie, während die Anwendung geladen wird.<br /><br />
                <LinearProgress variant="determinate" value={progress} />
              </DialogContentText>
            </DialogContent></>}
      </Dialog>
    </div>
  );
}